import { formatQty, qty } from '@app/shared';
import type { PreviewAffectedDocument, PreviewPaymentChange } from '@/entities/document';
import { formatDate } from '@/shared/lib/date';

/** Что изменится у затронутого документа помимо сумм: появится ли минус, предварительная
 * себестоимость, возврат сверх основания (§8.5). Сумма и себестоимость могут остаться прежними —
 * документ всё равно затронут. */
export function affectedNotes(doc: PreviewAffectedDocument): string[] {
  const notes: string[] = [];
  if (!qty(doc.qtyUncoveredBefore).eq(qty(doc.qtyUncoveredAfter))) notes.push(`без партии: ${formatQty(doc.qtyUncoveredBefore)} → ${formatQty(doc.qtyUncoveredAfter)} шт`);
  if (doc.provisionalBefore !== doc.provisionalAfter) notes.push(doc.provisionalAfter ? 'себестоимость станет предварительной' : 'себестоимость станет окончательной');
  if (!qty(doc.qtyOverBaseBefore).eq(qty(doc.qtyOverBaseAfter))) notes.push(`сверх основания: ${formatQty(doc.qtyOverBaseBefore)} → ${formatQty(doc.qtyOverBaseAfter)} шт`);
  if (doc.paidAmountBefore !== doc.paidAmountAfter) notes.push(`оплачено: ${doc.paidAmountBefore} → ${doc.paidAmountAfter}`);
  return notes;
}

export function paymentChangeText(payment: PreviewPaymentChange): string {
  switch (payment.change) {
    case 'DELETED':
      return 'будет удалён';
    case 'CREATED':
      return 'будет создан';
    case 'MOVED':
      return `перейдёт к контрагенту «${payment.counterpartyNameAfter ?? ''}»`;
    case 'RESCHEDULED':
      return `дата изменится на ${payment.payDateAfter ? formatDate(payment.payDateAfter) : '—'}`;
  }
}
